<template>
    <ui-modal :class-extra-name="css.container" :close="false" :width="544" height="auto" ref="modal" spacing="32px 56px">
        <!-- * 标题板块 -->
        <div :class="css.name" class="text-emphas font-bold">{{ $t("AAVCapsidViabilitys.ConsultForm.Name") }}</div>
        <!-- * 表单板块 -->
        <ui-form :class="css.form" :data="data" :rules="rules" ref="form">
            <ui-form-item prop="name">
                <div :class="[css.name, css.star]">{{ $t("FullName") }}</div>
                <div :class="[css.control]">
                    <ui-input
                        v-model="data.name"
                        name="name"
                        width="100%"
                        :maxlength="64"
                        :placeholder="$t('AAVCapsidViabilitys.Placeholder.Name')" />
                </div>
            </ui-form-item>

            <ui-form-item prop="org">
                <div :class="[css.name, css.star]">{{ $t("Organization") }}</div>
                <div :class="[css.control]">
                    <ui-input v-model="data.org" name="org" width="100%" :maxlength="128" :placeholder="$t('AAVCapsidViabilitys.Placeholder.Org')" />
                </div>
            </ui-form-item>

            <ui-form-item prop="job">
                <div :class="[css.name, css.star]">{{ $t("JobRole") }}</div>
                <div :class="[css.control]">
                    <ui-input v-model="data.job" name="job" width="100%" :maxlength="128" :placeholder="$t('AAVCapsidViabilitys.Placeholder.Job')" />
                </div>
            </ui-form-item>

            <ui-form-item prop="phone">
                <div :class="[css.name, $i18n.locale == 'zh' && css.star]">{{ $t("PhoneNumber") }}</div>
                <div :class="[css.control]">
                    <ui-input v-model="data.phone" name="phone" width="100%" :placeholder="$t('AAVCapsidViabilitys.Placeholder.Phone')" />
                </div>
            </ui-form-item>

            <ui-form-item prop="email">
                <div :class="[css.name, css.star]">{{ $t("Email") }}</div>
                <div :class="[css.control]">
                    <ui-input v-model="data.email" name="email" width="100%" :placeholder="$t('AAVCapsidViabilitys.Placeholder.Email')" />
                </div>
            </ui-form-item>
        </ui-form>

        <!-- * 底部控件 -->
        <div :class="css.controls" class="flex items-center justify-between">
            <ui-checkbox v-model="data.exist" value="Privacy Policy">
                <i18n-t scope="global" keypath="AgreeToOurPrivacyPolicy">
                    <template #content>
                        <ProjectRoute :to="{ name: 'Privacy' }" class="underline underline-offset-4 hover:text-main" target="_blank">
                            {{ $t("PrivacyPolicy").toLocaleLowerCase() }}
                        </ProjectRoute>
                    </template>
                </i18n-t>
            </ui-checkbox>

            <ui-button size="middle" @click="methods.submit">{{ $t("Submit") }}</ui-button>
        </div>

        <!-- * 关闭按钮 -->
        <div :class="css.close" class="absolute cursor-pointer transition duration-200" @click="methods.close">
            <ui-icon class="text-[16px]" name="close2" />
        </div>
    </ui-modal>
</template>

<script lang="ts" setup>
//* 组件库
import { UiIcon, UiModal, UiForm, UiFormItem, UiCheckbox, UiButton, UiInput } from "various-ui";
//* 组件属性
import type { Emits } from "./index";
import { useComposable } from "./src/composable";
//* 样式
import css from "./index.module.less";

//* 组件属性注册
const emits = defineEmits<Emits>();
//* 组合函数
const { data, rules, methods } = useComposable(emits);

//* 组件属性导出
defineExpose({
    open: methods.open,
    class: methods.close,
});
</script>
